/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';

/**
 * 
 * @export
 * @interface TextValueDto
 */
export interface TextValueDto {
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    setupParameterId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    groupId?: string;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueDto
     */
    isRequired?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueDto
     */
    isReadonly?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TextValueDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof TextValueDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    groupName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    groupHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TextValueDto
     */
    $type?: TextValueDtoTypeEnum;
}


/**
 * @export
 */
export const TextValueDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoSystemSetupParametersTextValueDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.SystemSetupParameters.TextValueDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type TextValueDtoTypeEnum = typeof TextValueDtoTypeEnum[keyof typeof TextValueDtoTypeEnum];



/**
 * Check if a given object implements the TextValueDto interface.
 */
export function instanceOfTextValueDto(value?: unknown): value is TextValueDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TextValueDtoTypeEnum)[0];
}

export function TextValueDtoFromJSON(json: any): TextValueDto {
    return TextValueDtoFromJSONTyped(json, false);
}

export function TextValueDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TextValueDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'setupParameterId': json['setupParameterId'] == null ? undefined : json['setupParameterId'],
        'groupId': json['groupId'] == null ? undefined : json['groupId'],
        'name': json['name'] == null ? undefined : json['name'],
        'isRequired': json['isRequired'] == null ? undefined : json['isRequired'],
        'isReadonly': json['isReadonly'] == null ? undefined : json['isReadonly'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'value': json['value'] == null ? undefined : json['value'],
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'groupHash': json['groupHash'] == null ? undefined : json['groupHash'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function TextValueDtoToJSON(value?: TextValueDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'setupParameterId': value['setupParameterId'],
        'groupId': value['groupId'],
        'name': value['name'],
        'isRequired': value['isRequired'],
        'isReadonly': value['isReadonly'],
        'isEnabled': value['isEnabled'],
        'iuid': value['iuid'],
        'origin': EntityOriginToJSON(value['origin']),
        'value': value['value'],
        'groupName': value['groupName'],
        'groupHash': value['groupHash'],
        '$type': value['$type'],
    });
}

